module.exports = __webpack_public_path__ + "static/media/china.3d58605.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/mapVideos/china.mp4
// module id = D+12
// module chunks = 6